import { createDashboardReduxModule } from 'utils/reduxDashboardModuleCreator'

export const resolvedIncidentWidgetRedux = createDashboardReduxModule({
  name: 'RESOLVED_INCIDENT_WIDGET',
  path: 'dashboard/home/resolvedIncidentWidget',
})
